import getCanAutoplaySilentVideo from "selectors/device/getCanAutoplaySilentVideo";
import getIsMobileSafari from "selectors/device/getIsMobileSafari";
import getIsTablet from "selectors/device/getIsTablet";
import { createSelector } from "reselect";

const getPlayerOptions = (state) => state.playerOptions;

const getForceDashPlayback = (state) => state.device.forceDashPlayback;
const getForceHlsPlayback = (state) => state.device.forceHlsPlayback;

//this.isMobileSafari && this.osVersionFloat >= 8;
export default createSelector(
  [
    getCanAutoplaySilentVideo,
    getForceDashPlayback,
    getForceHlsPlayback,
    getIsMobileSafari,
    getIsTablet,
    getPlayerOptions,
  ],
  (
    canAutoplaySilentVideo,
    forceDashPlayback,
    forceHlsPlayback,
    isMobileSafari,
    isTablet,
    playerOptions, // eslint-disable-line no-unused-vars
  ) => {
    const result = // eslint-disable-line no-unused-vars
      !canAutoplaySilentVideo ||
      (!forceDashPlayback &&
        !forceHlsPlayback &&
        isMobileSafari &&
        !isTablet &&
        !canAutoplaySilentVideo);

    return false;
  },
);
